export enum AiAssistantName {
  POLLY = 'POLLY',
  GRANT_WRITER = 'GRANT_WRITER',
  ANNIE = 'ANNIE',
  SANDBOX = 'SANDBOX',
}

export const assistantDetailsByName: Record<AiAssistantName, string> = {
  [AiAssistantName.POLLY]: 'Polly, your dedicated Polco Data Analyst',
  [AiAssistantName.GRANT_WRITER]:
    'Grace, your dedicated Polco Grant Writing Assistant',
  [AiAssistantName.ANNIE]: 'Annie, your dedicated Internal Assistant',
  [AiAssistantName.SANDBOX]: 'Sandbox, a custom AI assistant',
};

export interface StandardAssistant {
  readonly type: 'StandardAssistant';
  readonly id: AiAssistantName;
}

export interface PubAssistant {
  readonly type: 'PubAssistant';
  readonly id: string;
}

export interface OpenAIAssistant {
  readonly type: 'OpenAIAssistant';
  readonly id: string;
}

export type AiAssistant = StandardAssistant | PubAssistant | OpenAIAssistant;
